import React from 'react';
import fr from 'facet-rest';
import { FDBox } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import { ProposalProjectionSectionContainer } from 'Organisms/ProposalProjectionSection';

const ScenarioSelectionRedefinedScenarioDetailsContent = ({ resource }) => {
  return (
    <FDBox {...dataAttrs('scenario-selection-redefined-wizard-details-step-content')} width={'100%'}>
      {resource.withRelationship(fr.relationships.proposalProjectionSection.name, (rel) => {
        return (<ProposalProjectionSectionContainer relationship={rel} />);
      }, () => null)}
    </FDBox>
  );
};

ScenarioSelectionRedefinedScenarioDetailsContent.defaultProps = {
};

ScenarioSelectionRedefinedScenarioDetailsContent.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ScenarioSelectionRedefinedScenarioDetailsContent;
